<template>
     <div class="layout-w d-print-none">
        <!--------------------
        START - Mobile Menu
        -------------------->
        <div class="menu-mobile menu-activated-on-click color-scheme-light">
          <div class="mm-logo-buttons-w">
            <router-link class="mm-logo" :to="{name: 'Home'}">
              <img src="@/img/brand-drachei-big.svg" tag="a" alt="Dr.Achei">
            </router-link>
            <div class="mm-buttons">
              <div class="mobile-menu-trigger">
                <div class="os-icon os-icon-hamburger-menu-1"></div>
              </div>
            </div>
          </div>
          <div class="menu-and-user">
            <div class="logged-user-w">
              <div class="col-lg-1" v-if="naoLogado">                  
                  <button class="mr-2 mb-2 btn btn-outline-light btn-block dropdown-toggle btn-login" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Entrar
                  </button>
                  <div class="dropdown-menu dropdown-menu-right">
                    <router-link :to="{name: 'Login'}" class="dropdown-item" tag="a">Área Credenciado</router-link>
                    <a class="dropdown-item" tag="a" href="#" @click="loginCliente">Área do cliente</a>
                  </div>
                </div>
                <div class="col-lg-2" v-if="user">
                    
                    <div class="logged-user-w avatar-inline avatar-header" >
                        <div class="logged-user-i" style="color: #3E4B5B;">
                        <div class="avatar-w">
                            <i class="os-icon os-icon-user-male-circle2"></i>
                        </div>
                        <div class="logged-user-info-w">
                            <div class="logged-user-name">
                            {{ username }}
                            </div>
                            <div class="logged-user-role">
                            {{ user.role }}
                            <hr/>
                            <span v-if="rede" v-text="rede.nomeRede"></span>
                            </div>
                        </div>
                        <div class="logged-user-toggler-arrow">
                            <div class="os-icon os-icon-chevron-down"></div>
                        </div>
                        <div class="logged-user-toggler-arrow">
                            <div class="os-icon os-icon-chevron-down"></div>
                        </div>
                        <div class="logged-user-menu color-style-bright">
                            <div class="logged-user-avatar-info">
                            <div class="avatar-w">
                                <i class="os-icon os-icon-user-male-circle2"></i>
                            </div>
                            <div class="logged-user-info-w">
                                <div class="logged-user-name">
                                {{ username }}
                                </div>
                                <div class="logged-user-role">
                                {{ user.role }}
                                <hr />
                                NR. Sin Saúde: <span v-if="user.cartao" v-text="user.cartao.numeroCartao"></span>
                                </div>
                            </div>
                            </div>
                            <div class="bg-icon">
                            <i class="os-icon os-icon-wallet-loaded"></i>
                            </div>
                            <ul>
                              <li v-for="menu in menu[user.role]" :key="menu.descricao">
                                <router-link :to="{name: menu.url}" class="link-dashboard">
                                    <span>{{ menu.descricao }}</span>
                                </router-link>
                              </li>
                              <li>
                                  <a @click="logout()"><i class="os-icon os-icon-signs-11"></i><span>Sair</span></a>
                              </li>
                            </ul>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--------------------
            START - Mobile Menu List
            -------------------->
            <ul class="main-menu main-menu-mobile">
              <li class="has-sub-menu">
                <router-link :to="{name: 'Cadastrese-pergunta'}">
                    <span>Cadastre-se</span>
                </router-link>
              </li>
              <li class="has-sub-menu">
                <router-link :to="{name: 'QuemSomos'}">
                    <span>Quem Somos</span>
                </router-link>
              </li>
              <li class="has-sub-menu">
                <a target="_blank" href="http://blog.drachei.com.br">
                    <span>Blog</span>
                </a>
              </li>
              <li class="has-sub-menu">
                <router-link :to="{name: 'HomeProfissionais'}">
                    <span>Para Profissionais da Saúde</span>
                </router-link>
              </li>
              <li class="has-sub-menu">
                <router-link v-if="!logado" :to="{name: 'SinSaudeCard'}">
                    <span>Conheça nossos planos</span>
                </router-link>
              </li>
              
            </ul>
            <!--------------------
            END - Mobile Menu List
            -------------------->
      
          </div>
        </div>
        <!--------------------
        END - Mobile Menu
        --------------------><!--------------------
        START - Main Menu
        -------------------->
        <div class="menu-w color-scheme-dark color-style-bright menu-position-top menu-layout-compact menu-activated-on-hover">
          <div class="container">
            <div class="row">
                <div class="col-lg-3">
                    <div class="logo-w">
                        <router-link class="logo" :to="{name: 'Home'}">
                            <div class="brand">
                                <h1 class="drachei-brand"></h1>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="col align-items-center">
                    <ul class="main-menu menu-topo">
                      <li class="">
                            <router-link :to="{name: 'Cadastrese-pergunta'}">
                                <span>Cadastre-se</span>
                            </router-link>
                        </li>
                      <li class="">
                            <router-link :to="{name: 'QuemSomos'}">
                                <span>Quem Somos</span>
                            </router-link>
                        </li>
                        <li class="">
                            <a target="_blank" href="http://blog.drachei.com.br">
                                <span>Blog</span>
                            </a>
                        </li>
                        <li class="">
                            <router-link :to="{name: 'HomeProfissionais'}">
                                <span>Para Profissionais da Saúde</span>
                            </router-link>
                        </li>
                        <li class="">
                            <router-link v-if="!logado" :to="{name: 'SinSaudeCard'}">
                                <span>Conheça nossos planos</span>
                            </router-link>
                        </li>
                    </ul>
                </div>
                <div class="col-lg-1" v-if="naoLogado">                  
                  <button class="mr-2 mb-2 btn btn-outline-light btn-block dropdown-toggle btn-login" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Entrar
                  </button>
                  <div class="dropdown-menu dropdown-menu-right">
                    <router-link :to="{name: 'Login'}" class="dropdown-item" tag="a">Área Credenciado</router-link>
                    <a class="dropdown-item" tag="a" href="#" @click="loginCliente">Área do cliente</a>
                  </div>
                </div>
                <div class="col-lg-2" v-if="user">
                    
                    <div class="logged-user-w avatar-inline avatar-header" >
                        <div class="logged-user-i" style="color: #3E4B5B;">
                        <div class="avatar-w">
                            <i class="os-icon os-icon-user-male-circle2"></i>
                        </div>
                        <div class="logged-user-info-w">
                            <div class="logged-user-name">
                            {{ username }}
                            </div>
                            <div class="logged-user-role">
                            {{ user.role }}
                            <hr/>
                            <span v-if="rede" v-text="rede.nomeRede"></span>
                            </div>
                        </div>
                        <div class="logged-user-toggler-arrow">
                            <div class="os-icon os-icon-chevron-down"></div>
                        </div>
                        <div class="logged-user-toggler-arrow">
                            <div class="os-icon os-icon-chevron-down"></div>
                        </div>
                        <div class="logged-user-menu color-style-bright">
                            <div class="logged-user-avatar-info">
                            <div class="avatar-w">
                                <i class="os-icon os-icon-user-male-circle2"></i>
                            </div>
                            <div class="logged-user-info-w">
                                <div class="logged-user-name">
                                {{ username }}
                                </div>
                                <div class="logged-user-role">
                                {{ user.role }}
                                <hr />
                                  <b v-if="user.cartao">NR. SinSaude:</b> <span v-if="user.cartao" v-text="user.cartao.numeroCartao"></span>
                                  <span v-if="isCredenciado && rede" v-text="rede.nomeRede"></span>
                                </div>
                            </div>
                            </div>
                            <div class="bg-icon">
                            <i class="os-icon os-icon-wallet-loaded"></i>
                            </div>
                            <ul>
                              <li v-for="menu in menu[user.role]" :key="menu.descricao">
                                <router-link :to="{name: menu.url}">
                                    <span>{{ menu.descricao }}</span>
                                </router-link>
                              </li>
                              <li>
                                  <a @click="logout()"><i class="os-icon os-icon-signs-11"></i><span>Sair</span></a>
                              </li>
                            </ul>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import eventBus from '@/event-bus'
export default {
  mounted () {
    window.jQuery('.mobile-menu-trigger').on('click', function () {
      window.jQuery('.menu-mobile .menu-and-user').slideToggle(200, 'swing')
      return false
    })
    window.jQuery('.menu-mobile .main-menu li').on('click', function () {
      window.jQuery('.menu-mobile .menu-and-user').slideUp(200, 'swing')
      return false
    })
    window.jQuery('.mm-logo').on('click', function () {
      window.jQuery('.menu-mobile .menu-and-user').slideUp(200, 'swing')
      return false
    })
    window.jQuery('.link-dashboard').on('click', function () {
      window.jQuery('.menu-mobile .menu-and-user').slideUp(200, 'swing')
      return false
    })
  },

  computed: {
    logado () {
      return this.$store.getters.user
    },
    naoLogado () {
      return !this.$store.getters.user
    },
    user () {
      return this.$store.getters.user
    },
    rede () {
      return this.$store.getters.rede
    },
    isCredenciado () {
      return this.$store.getters.user.role === 'AdmRede' || this.$store.getters.user.role === 'AdminRede' || this.$store.getters.user.role === 'Administrador' || this.$store.getters.user.role === 'Atendente' || this.$store.getters.user.role === 'ATENDENTE'
    },
    username () {
      if (this.user.name) {
        let chucks = this.user.name.split(' ')
        if (chucks.length >= 2) {
          return `${chucks[0]} ${chucks[1]}`
        } else {
          return this.user.name
        }
      }
    }
  },
  data () {
    return {
      menu: {
        'DRACHEI': [
          {icon: '', descricao: 'Dashboard', url: 'HomeAdmCliente'}
        ],
        'AdmRede': [
          {icon: '', descricao: 'Dashboard', url: 'HomeAdmin'}
        ],
        'Administrador': [
          {icon: '', descricao: 'Dashboard', url: 'HomeAdmin'}
        ],
        'ATENDENTE': [
          {icon: '', descricao: 'Dashboard', url: 'HomeAdmin'}
        ]
      }

    }
  },
  methods: {
    logout () {
      if (this.user && this.user.role === 'DRACHEI') {
        this.$store.dispatch('logout')
      } else {
        this.$store.dispatch('logout')
          .then(() => this.$router.push({name: 'Login'}))
      }
    },
    loginCliente () {
      eventBus.$emit('openModal', 'login')
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Header.vue